module.exports = __webpack_public_path__ + "static/talk-business-politics-6c597ef1162ed47b825e54c4069e6766.png";